module.exports = {"411371060":"南阳高新区张衡街道","411371061":"南阳高新区百里奚街道","411371401":"中关村南阳科技产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411371.json
// module id = 1772
// module chunks = 0